import { h } from "preact";

export default function Footer() {
  return (
    <div className="comment-widget-footer">
      <span className="widget-footer-link">
        <a
          href="https://www.goemotify.com/products"
          target="_blank"
          rel="noreferrer"
        >
          <svg height="682.667" viewBox="0 0 512 512" width="682.667">
            <path d="M256 0C114.836 0 0 114.836 0 256s114.836 256 256 256 256-114.836 256-256S397.164 0 256 0zm112 277.332h-90.668V368c0 11.777-9.555 21.332-21.332 21.332s-21.332-9.555-21.332-21.332v-90.668H144c-11.777 0-21.332-9.555-21.332-21.332s9.555-21.332 21.332-21.332h90.668V144c0-11.777 9.555-21.332 21.332-21.332s21.332 9.555 21.332 21.332v90.668H368c11.777 0 21.332 9.555 21.332 21.332s-9.555 21.332-21.332 21.332zm0 0" />
          </svg>
          Add Emotify
        </a>
        <a
          href="https://www.goemotify.com/privacy"
          target="_blank"
          rel="noreferrer"
        >
          <svg viewBox="0 0 375.569 375.569">
            <path d="M299.32 107.07h-21.39l.177-16.338C278.5 41.107 238.465.407 188.84.003L188.106 0c-49.222 0-89.593 40.045-89.993 89.214l-.193 17.856H76.25c-12.94 0-23.466 10.526-23.466 23.465V318.57c0 31.43 25.57 57 57 57h156c31.43 0 57-25.57 57-57V130.536c.001-12.94-10.526-23.466-23.465-23.466zM138.11 89.594C138.333 62.248 160.76 40 188.106 40l.4.002c27.57.224 49.816 22.835 49.593 50.35l-.18 16.718H137.922l.19-17.477zm49.674 220.975s-69.76-37.786-69.76-85.913c0-21.48 17.412-38.9 38.9-38.9 12.58 0 23.76 5.974 30.87 15.237 7.11-9.263 18.3-15.237 30.87-15.237 21.48 0 38.9 17.412 38.9 38.9 0 48.565-69.76 85.913-69.76 85.913z" />
          </svg>
          Privacy
        </a>
      </span>
      <a
        href="https://www.goemotify.com/"
        className="footer-logo-link"
        target="_blank"
        rel="noreferrer"
      >
        <span>Powered by</span>
        <img
          // src="img/emotify-color-logo.svg"
          src={require("../assets/images/emotify-color-logo.svg")}
          className="widget-footer-logo"
          height="16"
        />
      </a>
    </div>
  );
}
